<div class="fluid-container">
  <app-sidebar class="sticky-top" [isOpen]="(sidebarSubject$|async)??false" [currentRoute]="(currentRoute$|async)??''" [isHandheld]="(isHandheld$|async)??false" [menu]="(menuItems$|async)??[]"
    (didNavigate)="sidebarSubject$.next(false)"></app-sidebar>
  <tdw-layout-header class="sticky-top" [isHandheld]="(isHandheld$|async)??false" appName="TDW Product Selector" [userProfile]="(profile$ | async) || undefined" [currentAccess]="(companyAccess$ | async) || undefined"
    [menuItems]="(menuItems$ | async) || []" [url]="(url$ | async) || ''" [isCollapsed]="(sidebarSubject$|async)??false" [version]="version" (toggleSidebar)="onToggleSidebar($event)" (search)="search($event)"
    (removeCachedItem)="showToastForRemoveCacheKey($event)" (logout)="logout()">
  </tdw-layout-header>
  <div class="content mt-3 me-3 mb-3">
    <router-outlet></router-outlet>
  </div>
  <app-footer [isHandheld]="(isHandheld$|async)??false"></app-footer>
</div>

<app-toasts [toasts]="(toasts$ | async) || []" (removeToast)="removeToast($event)"></app-toasts>
